export function getFlatFieldApiParams(building) {
  return {
    building: building?.value,
  }
}
